import axios from "axios";
import { get } from "lodash";
import { persistUser } from "../store/AuthContext";
import { buildQueryString, authHeader } from "../utils/helpers";
const { REACT_APP_SERVER_URL, REACT_APP_ORTHUS_URL, REACT_APP_API_BASIC_AUTH_USERNAME, REACT_APP_API_BASIC_AUTH_PASSWORD } = process.env;
const { REACT_APP_RIOT_URL, REACT_APP_RIOT_API_USER, REACT_APP_RIOT_API_TOKEN, REACT_APP_MINI_CATALOG_URL } = process.env;

//axios.defaults.auth = {username: REACT_APP_API_BASIC_AUTH_USERNAME, password: REACT_APP_API_BASIC_AUTH_PASSWORD};
//axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;

const apiInstance = axios.create({
  baseURL: REACT_APP_SERVER_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Auth-Token': REACT_APP_RIOT_API_TOKEN
  },
});

const riotInstance = axios.create({
  baseURL: REACT_APP_RIOT_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Auth-Token': REACT_APP_RIOT_API_TOKEN
  },
});

// unintercepted instance to ingnore global error handling
const riotDirectInstance = axios.create({
  baseURL: REACT_APP_RIOT_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Auth-Token': REACT_APP_RIOT_API_TOKEN
  },
});

riotInstance.interceptors.request.use(request => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user) {
    request.headers["X-User-Id"] = user.id;
    request.headers["X-Person-Token"] = user.token;
    request.headers["X-Data-Silo-Code"] = 'sec';
  }
  return request;
}, error => {
  return Promise.reject(error);
});

let refreshTokenPromise;
const onRefreshError = (refreshError) => {
  // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
  console.error('Token refresh failed:', refreshError);
  localStorage.removeItem('user');
  window.location.href = '/login?from=refresh_error';
  return Promise.reject(refreshError);
}

/*
riotInstance.interceptors.response.use(
  response => response, // Directly return successful responses.
  async error => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      const errorKey = get(error, 'response.data.error.key');
      
      originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
      try {
        if(!refreshTokenPromise) {
          let user = JSON.parse(localStorage.getItem('user'));
          const access_token_ttl = localStorage.getItem("access_token_ttl")
          console.log('refresh token called');
          // Make a request to your auth server to refresh the token.
          refreshTokenPromise = riotDirectInstance.post(`/v1/people/reset_access_token`, {access_token_ttl}, {
            headers: {"X-Person-Refresh-Token": user.refreshToken},
          }).then(({data}) => {
            console.log('refresh complete');
            refreshTokenPromise = null;
            persistUser(data).then(()=>{
              return Promise.resolve(data);  
            });
            
          }).catch(error => {
            console.log('refresh error!');
            return onRefreshError('refresh token call failed');
          });
        } else {
          console.log('refresh token call already in progress');
        }
        
        return refreshTokenPromise.then(data => {
          console.log('refresh promise resolved')
          return riotInstance(originalRequest); // Retry the original request with the new access token.
        })
        
      } catch (refreshError) {
        return onRefreshError(refreshError)
      }
    }
    return Promise.reject(error); // For all other errors, return the error as is.
  }
);
*/

function createAuthInterceptor(axiosInstance) {
  return axiosInstance.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = error.config;
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          if (!refreshTokenPromise) {
            let user = JSON.parse(localStorage.getItem('user'));
            const access_token_ttl = localStorage.getItem("access_token_ttl");
            console.log('refresh token called');

            refreshTokenPromise = riotDirectInstance.post(`/v1/people/reset_access_token`, { access_token_ttl }, {
              headers: { "X-Person-Refresh-Token": user.refreshToken },
            }).then(({ data }) => {
              console.log('refresh complete');
              refreshTokenPromise = null;
              return persistUser(data).then(() => data); // <-- bug fix, see note below
            }).catch(() => {
              console.log('refresh error!');
              return onRefreshError('refresh token call failed');
            });
          } else {
            console.log('refresh token call already in progress');
          }

          return refreshTokenPromise.then(() => {
            console.log('refresh promise resolved');
            return axiosInstance(originalRequest); // <-- uses whichever instance was passed in
          });

        } catch (refreshError) {
          return onRefreshError(refreshError);
        }
      }
      return Promise.reject(error);
    }
  );
}

apiInstance.interceptors.request.use(request => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user) {
    request.headers["X-User-Id"] = user.id;
    request.headers["X-Person-Token"] = user.token;
    request.headers["X-Data-Silo-Code"] = 'sec';
  }
  return request;
}, error => {
  return Promise.reject(error);
});

createAuthInterceptor(riotInstance);
createAuthInterceptor(apiInstance);

export const loginRequestOrthus = (email, password) => {
  return axios.post(`${REACT_APP_ORTHUS_URL}/v1/users/sign_in`,{ email, password });
}

export const loginRequest = (email, password, ttl) => {
  return axios.post(`${REACT_APP_RIOT_URL}/v1/people/sign_in`,{ email, password, access_token_ttl: ttl }, { headers: authHeader() } );
}

export const logoutRequest = (id) => {
  return axios.delete(`${REACT_APP_RIOT_URL}/v1/people/sign_out?person_id=${id}`, { headers: authHeader() } );
}

export const getImprintsRequest = (ids) => {
  if(Array.isArray(ids))
    ids = ids.join(',');
  return axios.get(`${REACT_APP_MINI_CATALOG_URL}/v2/imprints/ids_by_riot/${ids}`);
}

export const forgotPasswordRequest = (email) => {
  return axios.post(`${REACT_APP_RIOT_URL}/v1/people/recovery_password?from_api=true`, { person_id: email }, { headers: authHeader()});
}

export const getOverviewRequestGET = ({ page, search, sort, type }) => {
  const { search: searchTerm, format, range: {start, end}} = search;
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/overview?search=${searchTerm}&format=${format}&range_start=${start?start:''}&range_end=${end?end:''}&page=${page}&sort=${sort}`,
    { headers: authHeader() }
  );
};

export const getOverviewRequest = ({ page, search, sort, pageSize, type, all }) => {
  const { search: searchTerm, format, range: {start, end}} = search;
  return apiInstance.post(
    `${REACT_APP_SERVER_URL}/api/overview?&page=${page}&sort=${sort}&page_size=${pageSize}&all=${all}`, {search}, 
    { headers: authHeader() }
  );
};


export const getSalesSummaryRequest = ({ upc, type, page, filters, sort }) => {
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/sales/${upc}/${type}?filter=${filters}&page=${page}&sort=${sort}`,
    { headers: authHeader() }
  );
};

export const getGoodsRequest = ({ upc, page, filters, sort }) => {

  return axios.get(
    `${REACT_APP_SERVER_URL}/api/goods/${upc}?filter=${filters}&page=${page}&sort=${sort}`,
    { headers: authHeader() }
  );
};

export const getCurrentOrdersRequest = ({ upc, page, filters, sort }) => {
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/orders/${upc}?filter=${filters}&page=${page}&sort=${sort}`,
    { headers: authHeader() }
  );
};

export const getSalesOrdersRequest = ({ upc, start, end, mode, page, filters, sort }) => {
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/sales_orders/${upc}/${start}/${end}?mode=${mode}&filter=${filters}&page=${page}&sort=${sort}`,
    { headers: authHeader() }
  );
};

export const getSearchRequest = ({ query }) => {
  return apiInstance.post(
    `${REACT_APP_SERVER_URL}/api/search/${query}`,
    { },
    { headers: authHeader() }
  );
};

export const getFormatsRequest = () => {
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/search/formats`,
    { headers: authHeader() }
  );
};

export const getSalesTerritoriesRequest = ({ upc, page, filters, sort, page_size }) => {
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/sales_territories/${upc}?filter=${filters}&page=${page}&sort=${sort}&page_size=${page_size}`,
    { headers: authHeader() }
  );
};

export const getShipmentsRequest = ({ upc, type, page, filters, sort }) => {
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/shipments/${type}/${upc}?filter=${filters}&page=${page}&sort=${sort}`,
    { headers: authHeader() }
  );
};

export const getReportPartnersRequest = () => {
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/report/partners`,
    { headers: authHeader() }
  );
};

export const addReportRequest = (data) => {
  return axios.post(
    `${REACT_APP_SERVER_URL}/api/report/add`, data, 
    { headers: authHeader() }
  );
};

export const deleteReportRequest = (id) => {
  return axios.delete(
    `${REACT_APP_SERVER_URL}/api/report/delete/${id}`, 
    { headers: authHeader() }
  );
};

export const getLogEntriesRequest = () => {
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/import/logs`,
    { headers: authHeader() }
  );
};

export const getLabelsRequest = () => {
  return riotInstance.get(`/v1/labels`, {
  });
};

export const getUsersRequest = () => {
  return riotInstance.get(`/v1/people`, {
  });
};

export const getCurrentUserDetailsRequest = () => {
  return riotInstance.post(`/v1/people/details`, {}, {
  });
};

export const createUserRequest = (data) => {
  return riotInstance.post(`/v1/people`, data, {
  });
};

export const deleteUserRequest = (userId) => {  
  return riotInstance.delete(`/v1/people?person_id=${userId}`, {
  });
};

export const inviteUserRequest = (userId) => { 
  return riotInstance.post(`/v1/people/send_invite`, { person_id: userId }, {
  });
};


export const updateUserRequest = (data) => {
  return riotInstance.patch(`/v1/people`, data, {
  });
};

export const updatePasswordRequest = (data) => {
  return riotInstance.post(`${REACT_APP_RIOT_URL}/v1/people/change_password`, data, {
  });
};

export const getProductMetadataRequest = (upc) => {
  return riotInstance.get(`/v1/releases/${upc}`, {
  });
};
